<template>
  <Toolbar class="p-mb-4 p-mt-4 p-p-2">
    <template #start>
      <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Locations') }}</div>
<!--      <div class="p-p-1" v-show="$store.getters.effectiveRole === constants.userRoles.superAdmin">-->
      <div class="p-p-1" v-if="!$store.getters.isTrialTenant">
<!--        <AddNewButton :disabled="tenantDataIsLoading || (items?.length >= 5 && $store.getters.effectiveRole !== constants.userRoles.superAdmin)"-->
        <AddNewButton :disabled="tenantDataIsLoading || (items?.length >= 5 && $store.getters.effectiveRole !== constants.userRoles.superAdmin)"
                      :loading="tenantDataIsLoading"
                      :label="$t('Add')"
                      @click="addNewItem"/>
      </div>
    </template>
  </Toolbar>

  <Spinner v-if="isLoading"/>
  <DesktopDataTable v-else
                    :dataTableIsLoading="dataTableIsLoading"
                    :showHeader="false"
                    :itemsArrayIsEmpty="itemsArrayIsEmpty"
                    :sort="sort"
                    :showSearchInput="false"
                    :actionButtonsCount="actionButtonsCount"
                    @sort-items="sortItems"
                    :headers="[
                      {name: 'is_primary', width: '40px', sortable: false},

                      {name: 'name', title: $t('locationPublicNameLabel'), hint: $t('locationPublicNameHint'), sortable: false},
                      {name: 'status', title: $t('active'), sortable: false},
                      {name: 'address', title: $t('Address'), sortable: false},
                      // {name: 'country_name', title: $t('Country'), sortable: false},
                      // {name: 'phone', title: $t('Phone'), sortable: false},
                      // {name: 'email', title: $t('Email'), sortable: false},
                      // {name: 'website', title: $t('Website'), sortable: false},
                      {name: 'contacts', title: $t('Contacts'), sortable: false},
                      {name: 'company_name', title: $t('Company'), sortable: false},
                      {name: 'slug', title: $t('Short Name'), sortable: false},
                      {name: 'created_at', title: $t('Created'), sortable: true},

                  ]">
    <template v-slot:body>
      <tr v-for="(item, index) of items"
          :key="item.id ?? index"
          :class="{ 'updated-item': isItemUpdated(item.id) }">
        <td>
          <div class="p-d-flex p-ai-center">
            <i class="pi pi-star theme-color" v-if="item.is_primary" v-tooltip="$t('primaryLocationTooltip')"/>
            <i v-else
               class="pi pi-star"
               :class="{
                 pointer: canManage && !setPrimaryInFlight,
                 'text-color-secondary': !canManage || setPrimaryInFlight
               }"
               v-tooltip="canManage ? $t('setAsPrimaryLocationTooltip') : null"
               @click="setPrimaryLocation(item)"/>
          </div>
        </td>

        <td>
          <div v-if="item.public_name">
            {{ item.public_name }}
          </div>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <i class="pi pi-check green-color" v-if="item.status === 1"/>
          <i class="pi pi-times warning-color" v-else/>
        </td>

        <td>
          <div v-if="addressLine(item)">
            <span>{{ addressLine(item) }}</span>
          </div>
          <i v-else class="ti-minus"/>
        </td>

<!--        <td>-->
<!--          <span v-if="item.phone_code && item.phone_number">+{{ item.phone_code }} {{ item.phone_number }}</span>-->
<!--          <i v-else class="ti-minus"/>-->
<!--        </td>-->

<!--        <td>-->
<!--          <span v-if="item.email">{{ item.email }}</span>-->
<!--          <i v-else class="ti-minus"/>-->
<!--        </td>-->

<!--        <td>-->
<!--          <span v-if="item.website">{{ item.website }}</span>-->
<!--          <i v-else class="ti-minus"/>-->
<!--        </td>-->

        <td class="location-contacts">
          <div v-if="hasLocationContacts(item)" class="location-contacts__list">

            <div v-if="locationPhone(item)" class="location-contacts__row">
              {{ locationPhone(item) }}
            </div>

            <div v-if="item.email" class="location-contacts__row">
              {{ item.email }}
            </div>

            <div v-if="item.website" class="location-contacts__row">
              {{ item.website }}
            </div>

          </div>

          <i v-else class="ti-minus"/>
        </td>

        <td>
          <span v-if="item.company?.name">{{ item.company.name }}</span>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <span v-if="item.slug">{{ item.slug }}</span>
          <i v-else class="ti-minus"/>
        </td>

        <td class="table-date-line">
          <span v-if="item.created_at">
            {{ formatBy(item.created_at, item.creator) }}
          </span>
          <i v-else class="ti-minus"/>
        </td>

        <td v-show="actionButtonsCount">
          <div class="actions">
            <Button :disabled="!$store.getters.isOwnerOrHigher || dataTableIsLoading || tenantDataIsLoading || !item.slug"
                    @click="goToLocationSettings(item)"
                    v-tooltip.top="$t('Settings')"
                    :loading="item.isLoading"
                    icon="ti-settings"
                    class="p-button-secondary p-button-raised"/>
<!--            <EditButton :disabled="!$store.getters.isOwnerOrHigher || dataTableIsLoading || tenantDataIsLoading" @click="editItem(item)"/>-->
            <EditButton :allowWhenBillingLocked="true"
                        :disabled="!$store.getters.isOwnerOrHigher ||  dataTableIsLoading ||tenantDataIsLoading"
                        @click="editItem(item)"/>
          </div>
        </td>

      </tr>
    </template>
  </DesktopDataTable>

  <OwnPaginator v-show="items?.length"
                :rows="pagination.perPage"
                :currentPage="pagination.currentPage - 1"
                :totalPages="pagination.pageCount"
                :totalRecords="pagination.totalCount"
                :rowsPerPageOptions="[5,10,25,50,100,200]"
                :pageLinkSize="11"/>

  <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>


  <LocationModal :visible="itemModal"
                 :item="item"
                 @update-items="updateItems"
                 @close="closeItemModal"/>
</template>

<script>
import httpClient from '@/services/http.services'
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";
import LocationModal from "@/pages/account/components/LocationModal";
import labelMixin from "@/mixins/labelMixin";
import constants from "@/constants";

export default {
  mixins: [ datatableMixins, showErrorsMixins, formatMixins, labelMixin ],
  components: { LocationModal },
  props: {
    // tenant: [Object,null],
    tenantDataIsLoading: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    '$route'() {
      const route = this.$route.path.split('/')
      if (this.$route.path === '/login' || route.indexOf('account') === -1 || route.indexOf('locations') === -1) {
        return false
      }
      this.checkRouteQuery()
      this.getItems()
    },
  },
	data() {
		return {
      setPrimaryInFlight: false,
      fieldsExpand: 'creator,company,country_name',
      apiLink: 'location',
      routePath: '/locations',
      sort: {
        column: 'id',
        direction: '-',
      },
      constants
		}
	},
  mounted() {
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.$store.commit('SET_FETCH_IN_FLIGHT', false)
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    goToLocationSettings(item) {
      if (!item?.slug) return
      item.isLoading = true
      this.$router.push({path: `/location-settings/${item.slug}`})
    },
    async setPrimaryLocation(item) {
      const locationId = item?.id
      if (!locationId || this.setPrimaryInFlight || !this.$store.getters.isOwnerOrHigher) return
      this.setPrimaryInFlight = true

      try {
        const { data, status } = await httpClient.post('location/set-primary-location', { locationId })
        if (status === 200 && data?.success) {
          this.items?.forEach(i => i.is_primary = false)
          item.is_primary = true
          this.$toast.add({ severity: 'success', detail: this.$t('Data updated'), life: settings.toastLife })
        } else {
          this.showUnknownError()
        }
      } catch (err) {
        this.showError(err)
      } finally {
        this.setPrimaryInFlight = false
      }
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('locations')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.items = []
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (ctrl && this._abortors?.locations === ctrl) {
          this._abortors.locations = null
        }
      }
    },
    hasLocationContacts(item) {
      return !!(this.locationPhone(item) || item.email || item.website)
    },

    locationPhone(item) {
      if (!item.phone_code && !item.phone_number) return null

      if (item.phone_code && item.phone_number) {
        return `+${item.phone_code} ${item.phone_number}`
      }

      return item.phone_number || `+${item.phone_code}`
    },
	},
  computed: {
    canManage() {
      return this.$store.getters.isOwnerOrHigher
    },
    actionButtonsCount() {
      return this.canManage ? 2 : 0
    },
  }
}
</script>
<style scoped lang="scss">
.location-contacts__list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  line-height: 1.25;
}

.location-contacts__row {
  word-break: break-word;
}
</style>
<style scoped lang="scss">
td {
  height: 44px;
}
</style>